(function() {
  var navItems = document.querySelectorAll('.header__nav-item--has-sub');
  var submenus = document.querySelectorAll('.header__submenu');
  var searchBtn = document.querySelector('.header__search-btn');
  var searchOverlay = document.querySelector('.header__search-overlay');
  var searchBackdrop = document.querySelector('.header__search-backdrop');
  var searchInput = document.querySelector('.header__search-input');
  var hamburger = document.querySelector('.header__hamburger');
  var drawer = document.querySelector('.header__drawer');
  var drawerBackdrop = document.querySelector('.header__drawer-backdrop');
  var closeTimeout = null;

  function closeAllSubmenus() {
    submenus.forEach(function(s) { s.classList.remove('header__submenu--open'); });
    navItems.forEach(function(n) { n.classList.remove('header__nav-item--open'); });
  }

  function closeSearch() {
    if (searchOverlay) searchOverlay.classList.remove('header__search-overlay--open');
  }

  function positionSubmenuCard(submenu, navItem) {
    var card = submenu.children[0];
    if (!card) return;
    var remPx = parseFloat(window.getComputedStyle(document.documentElement).fontSize);
    var margin = remPx * 1.6;
    var left = navItem.getBoundingClientRect().left;
    var maxLeft = document.documentElement.clientWidth - card.offsetWidth - margin;
    left = Math.min(left, maxLeft);
    left = Math.max(left, margin);
    submenu.style.setProperty('--submenu-left', left + 'px');
  }

  function openSubmenu(name) {
    closeSearch();
    closeAllSubmenus();
    var submenu = document.querySelector('[data-submenu="' + name + '"]');
    var navItem = document.querySelector('[data-nav="' + name + '"]');
    if (submenu && navItem) {
      positionSubmenuCard(submenu, navItem);
      submenu.classList.add('header__submenu--open');
      navItem.classList.add('header__nav-item--open');
    }
  }

  function scheduleClose() {
    closeTimeout = setTimeout(closeAllSubmenus, 150);
  }

  function cancelClose() {
    if (closeTimeout) {
      clearTimeout(closeTimeout);
      closeTimeout = null;
    }
  }

  navItems.forEach(function(item) {
    item.addEventListener('mouseenter', function() {
      cancelClose();
      openSubmenu(item.dataset.nav);
    });
    item.addEventListener('mouseleave', scheduleClose);
  });

  submenus.forEach(function(submenu) {
    submenu.addEventListener('mouseenter', cancelClose);
    submenu.addEventListener('mouseleave', scheduleClose);

    submenu.children[0].addEventListener('click', function(e) {
      e.stopPropagation();
    });
    submenu.addEventListener('click', closeAllSubmenus);
  });

  if (searchBtn && searchOverlay) {
    searchBtn.addEventListener('click', function() {
      closeAllSubmenus();
      var isOpen = searchOverlay.classList.toggle('header__search-overlay--open');
      if (isOpen && searchInput) searchInput.focus();
    });
  }

  if (searchOverlay) {
    searchOverlay.children[0].addEventListener('click', function(e) {
      e.stopPropagation();
    });
    searchOverlay.addEventListener('click', closeSearch);
  }

  function openDrawer() {
    drawer.classList.add('header__drawer--open');
    drawerBackdrop.classList.add('header__drawer-backdrop--open');
    hamburger.classList.add('header__hamburger--open');
    hamburger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer.classList.remove('header__drawer--open');
    drawerBackdrop.classList.remove('header__drawer-backdrop--open');
    hamburger.classList.remove('header__hamburger--open');
    hamburger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (hamburger && drawer && drawerBackdrop) {
    hamburger.addEventListener('click', function() {
      if (drawer.classList.contains('header__drawer--open')) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });
    drawerBackdrop.addEventListener('click', closeDrawer);
  }

  document.querySelectorAll('.header__drawer-nav-item[aria-expanded]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var group = btn.closest('.header__drawer-nav-group');
      var isOpen = btn.getAttribute('aria-expanded') === 'true';

      document.querySelectorAll('.header__drawer-nav-group').forEach(function(g) {
        g.classList.remove('header__drawer-nav-group--open');
        var b = g.querySelector('.header__drawer-nav-item[aria-expanded]');
        if (b) b.setAttribute('aria-expanded', 'false');
      });

      if (!isOpen && group) {
        group.classList.add('header__drawer-nav-group--open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  window.addEventListener('resize', closeAllSubmenus);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeAllSubmenus();
      closeSearch();
      if (drawer && drawer.classList.contains('header__drawer--open')) closeDrawer();
    }
  });
})();
